import { createSlice } from "@reduxjs/toolkit";

// Metadata storage for `_filtering`'s shared filtering system
// (useEntityFilters/useFilterMetadata, ADR-F006) - nearly every migrated
// feature's own useXFilters hook feeds this a selectMetadata/setMetadataAction
// pair. `data`/`setData` is a separate, generic catch-all field, not filter
// metadata - still has real old-tree consumers (see docs/bug-sheet.md).
const initialState = {
  companyFilters: null,
  selfServeUserFilters: null,
  marketsFilters: null,
  data: null,
  billingFilters: null,
  featureFilters: null,
  productsFilters: null,
  planFilters: null,
  usageSourcesFilters: null,
  usageCompilationsFilters: null,
  subscriptionsFilters: null,
  proposalFilters: null,
  usersFilters: null,
  invoiceFilters: null,
  paymentsFilters: null,
  upsellDownsellFilters: null,
  importsFilters: null,
  permissionFilters: null,
  contactsFilters: null,
  rolesFilters: null,
  exportFilters: null,
  billingLogicFilters: null,
  usageCollectionFilters: null,
};

const dataSlice = createSlice({
  name: "data",
  initialState,
  reducers: {
    setSelfServeUserFilters(state, action) {
      state.selfServeUserFilters = action.payload;
    },
    setProductsFilters(state, action) {
      state.productsFilters = action.payload;
    },
    setMarketFilters(state, action) {
      state.marketsFilters = action.payload;
    },
    setBillingFilters(state, action) {
      state.billingFilters = action.payload;
    },
    setFeatureFilters(state, action) {
      state.featureFilters = action.payload;
    },
    setCompanyFilters(state, action) {
      state.companyFilters = action.payload;
    },
    setPlanFilters(state, action) {
      state.planFilters = action.payload;
    },
    setData(state, action) {
      state.data = action.payload;
    },
    setUsageSourcesFilters(state, action) {
      state.usageSourcesFilters = action.payload;
    },
    setUsageCompilationsFilters(state, action) {
      state.usageCompilationsFilters = action.payload;
    },
    setSubscriptionsFilters(state, action) {
      state.subscriptionsFilters = action.payload;
    },
    setProposalFilters(state, action) {
      state.proposalFilters = action.payload;
    },
    setUsersFilters(state, action) {
      state.usersFilters = action.payload;
    },
    setInvoiceFilters(state, action) {
      state.invoiceFilters = action.payload;
    },
    setPaymentsFilters(state, action) {
      state.paymentsFilters = action.payload;
    },
    setUpsellDownsellFilters(state, action) {
      state.upsellDownsellFilters = action.payload;
    },
    setImportsFilters(state, action) {
      state.importsFilters = action.payload;
    },
    setPermissionFilters(state, action) {
      state.permissionFilters = action.payload;
    },
    setContactsFilters(state, action) {
      state.contactsFilters = action.payload;
    },
    setRolesFilters(state, action) {
      state.rolesFilters = action.payload;
    },
    setExportFilters(state, action) {
      state.exportFilters = action.payload;
    },
    setBillingLogicFilters(state, action) {
      state.billingLogicFilters = action.payload;
    },
    setUsageCollectionFilters(state, action) {
      state.usageCollectionFilters = action.payload;
    },
  },
});

export const {
  setSelfServeUserFilters,
  setMarketFilters,
  setBillingFilters,
  setData,
  setPermissionFilters,
  setFeatureFilters,
  setProductsFilters,
  setCompanyFilters,
  setPlanFilters,
  setUsageSourcesFilters,
  setUsageCompilationsFilters,
  setSubscriptionsFilters,
  setProposalFilters,
  setUsersFilters,
  setInvoiceFilters,
  setPaymentsFilters,
  setUpsellDownsellFilters,
  setImportsFilters,
  setContactsFilters,
  setRolesFilters,
  setExportFilters,
  setBillingLogicFilters,
  setUsageCollectionFilters,
} = dataSlice.actions;

export default dataSlice.reducer;
